import React from 'react';
import I18n from 'i18n-js';
import classNames from 'classnames';

import { RCIconButton } from '../';
import { XIcon, XCircleFillIcon } from '../../icons/react';
import { RCButtonProps } from '../RCButton/RCButton';

export interface RCCloseButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>
  'aria-label'?: string;
  useAltIcon?: boolean;
  showTooltip?: boolean;
  variant?: RCButtonProps['variant'];
  size?: RCButtonProps['size'];
}

export const RCCloseButton = React.forwardRef<HTMLButtonElement, RCCloseButtonProps>(
  function RCCloseButton({
    onClick,
    'aria-label': ariaLabel,
    useAltIcon = false,
    showTooltip = false,
    variant = 'transparent',
    size = 'small',
  }: RCCloseButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>, ref) {
    return (
      <div className={classNames(
        'rc-close-button',
        { 'rc-close-button--alt': useAltIcon },
      )}>
        <RCIconButton
          label={ariaLabel || I18n.t('cadence.RCCloseButton.defaultLabel')}
          onClick={onClick}
          svgComponent={!useAltIcon ? XIcon : XCircleFillIcon}
          hideTooltip={!showTooltip}
          ref={ref}
          variant={variant}
          size={size}
        />
      </div>
    );
  },
);
